// bootstrap/sentry.js
import * as Sentry from '@sentry/vue'

export function initSentry (Vue, router) {
	if (!process.env.VUE_APP_SENTRY_DSN) {
		return
	}

	Sentry.init({
		Vue,
		dsn: process.env.VUE_APP_SENTRY_DSN,
		environment: process.env.VUE_APP_SENTRY_ENVIRONMENT ||
                     process.env.NODE_ENV ||
                     process.env.AWS_ENV,

		integrations: [
			Sentry.browserTracingIntegration({
				router: router.VueRouter
			}),
			Sentry.replayIntegration(getReplayConfig())
		],

		tracesSampleRate: 0,
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: 0,
		sendDefaultPii: false,

		beforeSend (event, _hint) {
			if (event.contexts?.operation) {
				return event
			}
			return null
		}
	})
}

function getReplayConfig () {
	return {
		maskAllText: false,
		blockAllMedia: false,
		networkDetailAllowUrls: [
			window.location.origin,
			'backend.recar.lt',
			/backend\.recar\.lt/
		],
		// Never capture GraphQL payloads in replays: auth/MFA operations carry
		// TOTP secrets, verification codes, Cognito session keys and tokens.
		networkCaptureBodies: false,
		networkRequestHeaders: [
			'Accept',
			'Content-Type',
			'X-Request-ID'
		],
		networkResponseHeaders: [
			'Content-Type',
			'Content-Length',
			'X-Request-ID'
		]
	}
}
